import { render, staticRenderFns } from "./mortgage-list.vue?vue&type=template&id=0f1ec1f0"
import script from "./mortgage-list.vue?vue&type=script&lang=ts"
export * from "./mortgage-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports